/*
=========================================================
* Material Kit 2 React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import LegalDocumentPage from "../components/LegalDocumentPage";

const sections = [
  {
    title: "Overview",
    body:
      "Volta Software (“we”, “us”) operates applications such as WednesdayClub, Qurated and related services. This policy describes how we collect, use, and protect information when you use our products or this website.",
  },
  {
    title: "Information we collect",
    body:
      "Depending on the product you use, we may collect account information (such as email or username), usage data needed to run the service, and information you submit voluntarily (for example, reviews or profile details). Some apps use third-party sign-in and hosting services to authenticate accounts and store data.",
  },
  {
    title: "How we use information",
    body:
      "We use collected information to provide and improve our applications, maintain security, respond to support requests, and comply with legal obligations. We do not sell personal information.",
  },
  {
    title: "Sharing",
    body:
      "We may share information with service providers that help us operate our apps (for example, authentication, analytics, or hosting), when required by law, or to protect the rights and safety of users and Volta Software.",
  },
  {
    title: "Your choices",
    body:
      "You may contact us to request access, correction, or deletion of account-related data where applicable. You can also stop using an app or uninstall browser extensions at any time.",
  },
  {
    title: "Contact",
    body: "Questions about this policy can be sent to admin@voltasoftware.net.",
  },
];

function PrivacyVoltaSoftware() {
  return <LegalDocumentPage title="Privacy Policy" sections={sections} />;
}

export default PrivacyVoltaSoftware;
